export default __webpack_public_path__ + "static/media/roboto.93bdb703.png";